module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/business-units/marketing/marketing.component.css
// module id = ./src/app/web/game/management/business-units/marketing/marketing.component.css
// module chunks = main